import { Component, HostListener, OnInit } from "@angular/core";
import { ActivatedRoute, Router, ParamMap } from "@angular/router";
import { ThemePalette } from "@angular/material/core";
import { CustomEventNRService } from "../services/custom-event-nr.service";
import { StandardService } from "../services/standard.service";
@Component({
  selector: "app-standard-search-filter",
  templateUrl: "./standard-search-filter.component.html",
  styleUrls: ["./standard-search-filter.component.scss"],
})
export class StandardSearchFilterComponent implements OnInit {
  searchQuery: string;
  showSuggestions :boolean = false;
  suggestionResults :any =["Drive Thru","Drive Thru","Drive Thru",]
  filterOptions: any = [
    { id: "0", option: "All content" },
    { id: "1", option: "Global Building Standards" },
    { id: "2", option: "Global Equipment Standards" },
    { id: "3", option: "Global Operation Standards" },
    { id: "4", option: "Global Approved Solutions" },
    { id: "5", option: "Upcoming Standards" },

  ];
  popularSearches: string[] = [
    "Security cameras",
    "LOV fryer",
    "Crew room",
    "Drive thru",
    "Food safety",
  ];
  selectedOption: any;
  searchColor: ThemePalette = "primary";
  invalidQuery: Boolean = false;
  isContentTypeDropdownOpen = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private customEventNRService: CustomEventNRService,
    private standardService: StandardService
  ) {}
  ngOnInit() {
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      this.searchQuery = params.get("query") || "";

      this.selectedOption =
        this.filterOptions.find((e) => e.id == params.get("type")) ||
        this.filterOptions[0]; // Set default option if not provided
    });

    // Falls back to the hardcoded list above when New Relic isn't
    // configured yet, or returns no data for this time window.
    this.standardService.getPopularSearches().subscribe({
      next: (data) => {
        if (data && data.length) {
          this.popularSearches = data.map((d) => d.searchKey);
        }
      },
      error: () => void 0,
    });
  }

  selectOption(option: any) {
    this.selectedOption = option;
  }

  toggleContentTypeDropdown() {
    this.isContentTypeDropdownOpen = !this.isContentTypeDropdownOpen;
  }

  applyContentTypeFilter() {
    this.isContentTypeDropdownOpen = false;
    if (this.searchQuery) {
      this.apply();
    }
  }

  @HostListener("document:click", ["$event"])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest(".content-type-filter-wrapper")) {
      this.isContentTypeDropdownOpen = false;
    }
  }
  onSearchInputChange(){
    console.log("Query changes", this.searchQuery)
    this.showSuggestions = this.searchQuery.length > 2;
  }

  apply() {
    if (this.searchQuery == "") {
      this.invalidQuery = true;
      return;
    }
    this.invalidQuery = false;
    this.showSuggestions = false;
    this.router.navigate(["/standards-search"], {
      queryParams: { query: this.searchQuery, type: this.selectedOption.id },
    });
  }
  show(){
    // alert("clicked")
  }
  showAlert(event: KeyboardEvent) {
    void 0;
  }  
}
